import { render, staticRenderFns } from "./Openbox.vue?vue&type=template&id=242874c8&"
import script from "./Openbox.vue?vue&type=script&lang=js&"
export * from "./Openbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports